

import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util.service';
import { NodataFoundComponent } from '../../widget/nodata-found/nodata-found.component';
import { CommonSkeletonComponent } from '../../skeleton/common-skeleton/common-skeleton.component';
import { TimesPipe } from '../../pipe/TimesPipe';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-notification-config',
  standalone: true,
  imports: [CommonModule, FormsModule, NodataFoundComponent, CommonSkeletonComponent, TimesPipe],
  templateUrl: './notification-config.component.html',
  styleUrls: ['./notification-config.component.scss']
})
export class NotificationConfigComponent implements OnInit,OnDestroy{
  notificationData = [
    { category: 'Job', items: ['Job Posted', 'Job Updated', 'Job Closed', 'Job on Hold', 'Job Reopened', 'Job Filled', 'Job Invite', 'Job View'] },
    { category: 'Candidate', items: ['Candidate Available', 'Candidate Unavailable', 'Candidate - Rejected', 'Candidate - Shortlisted', 'Candidate - Interview Scheduled', 'Candidate - Interview Reject', 'Candidate - Selected (Offer Released)', 'Candidate - Pre-Onboarding'] },
    { category: 'Job Applicant', items: ['Candidate - Applied', 'Candidate - Withdrawn', 'Candidate - Interview Accepted', 'Candidate - Interview Rejected', 'Candidate - Offer Accepted', 'Candidate - Offer Declined'] },
    { category: 'Chat', items: ['Chat - Message Received'] },
    { category: 'Teams', items: ['New Team', 'Team Updated', 'Team - Join Request', 'New Post', 'New Message'] },
    { category: 'Connections', items: ['New Connection'] },
    { category: 'Networks', items: ['New Network', 'New Post', 'New Message'] },
    { category: 'Business', items: ['Follow Request', 'New Post', 'New Message'] },
    { category: 'Community', items: ['New Member', 'New Post', 'New Message'] },
    { category: 'Personal', items: ['New Post', 'New Message'] }
  ];

  notificationSettings: { [category: string]: { [item: string]: {description:string,type:any,defaultNotify:any, inApp: boolean; email: boolean } } } = {};
  categoryChecked: { [category: string]: boolean } = {};

  userId:any;
  userName:any;
  userType:any;


  constructor(private util:UtilService,private api:ApiService , private cdr: ChangeDetectorRef) {
    // this.initializeSettings();
    
    
  }

  ngOnInit(): void {
    console.log('insidd',this.notificationSettings);
    this.notificationSettings = {}; 
    this.userType = localStorage.getItem('userType') || '';
    this.userId = localStorage.getItem('userId') || '';
    this.userName = localStorage.getItem('userName') || '';
    this.getBlockedList(this.userId);
  }

  


  ngOnDestroy(): void {
    this.subject.unsubscribe();
    this.subject1.unsubscribe();
    this.notificationList = [];
    this.notificationSettings = {};
  }

  initializeSettings() {
    // this.notificationData.forEach(category => {
    //   this.notificationSettings[category.category] = {};
    //   category.items.forEach(item => {
    //     this.notificationSettings[category.category][item] = { inApp: false, email: false };
    //   });
    // });
  }
  toggleState(event: any) {
    console.log("Toggle State: ", event.target.checked ? "ON" : "OFF");
  }

  toggleCategory(category: any, event: any) {
    const isChecked = event.target.checked;
    category.items.forEach((item: any) => {
      if(item.type == 'NOTIFICATION' && !item.defaultNotify){
        this.notificationSettings[category.category][item.notifyType].inApp = isChecked;
      }else if(item.type == 'EMAIL' && !item.defaultNotify){
        this.notificationSettings[category.category][item.notifyType].email = isChecked;
      }
    });
  }

  isCategoryChecked(category: any): boolean {
    return category.items.every(item =>
      (this.notificationSettings[category.category][item.notifyType]?.type == 'NOTIFICATION' 
        && this.notificationSettings[category.category][item.notifyType]?.inApp) ||
      (this.notificationSettings[category.category][item.notifyType]?.type == 'EMAIL'  &&
      this.notificationSettings[category.category][item.notifyType]?.email)
    );
  }


  categoryOrder:any[] = [
    'JOB',
    'CANDIDATE',
    'NETWORK',
    'BUSINESS'
  ]
  notificationList:any[] = [];
  subject1:Subscription;
  getNotificationsList(userType:any){
    this.util.startLoader();
    const payload = {
      userRole: userType,
      userId : this.userId,
      adminStatus:'ACTIVE'
    }
    this.isLoading= true;
    this.subject1 = this.api.create('notification/findUserTypeNotification',payload).subscribe((res:any) =>{
      this.util.stopLoader();
      if(res.code == '00000'){
        const data = res.data?.UserTypeListing;
        if(data){
          const values = data[0]?.notifyList;
          const groupedByDomain = Object.values(
            values.reduce((acc, item) => {
              const domain = item.domain;
              if (!acc[domain]) {
                acc[domain] = {
                  category: domain,
                  items: []
                };
              }
              acc[domain].items.push({
                description: item.description,
                notifyType: item.notifyType,
                order: item.order,
                type: item.type,
                defaultNotify: item.defaultNotify
              });
              return acc;
            }, {} as Record<string, { category: string; items: any[] }>)
          ).sort((a:any, b:any) =>{
              const aIndex = this.categoryOrder.indexOf(a.category);
              const bIndex = this.categoryOrder.indexOf(b.category);

              // Put unknown categories at the end
              return (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex);
            }
          );

          groupedByDomain.forEach((group:any) => {
            group.items.sort((a, b) => a.order - b.order);
          });

          console.log('groupeddomain: ',groupedByDomain);

          groupedByDomain.forEach((category:any) => {
            this.notificationSettings[category.category] = {};
            this.categoryChecked[category.category] = true;

            category.items.forEach(item => {
              this.notificationSettings[category.category][item.notifyType] = {
                description: item.description,
                type : item.type,
                defaultNotify : item.defaultNotify,
                inApp: item.type == 'NOTIFICATION',
                email: item.type == 'EMAIL'
              };
            });
          });

          this.notificationList = groupedByDomain;

          for (const category of this.notificationList) {
            for (const item of category.items) {
              const notifyType = item.notifyType;

              if (this.blockedList.includes(notifyType)) {
                const current = this.notificationSettings[category.category][notifyType];
                console.log('blocked :: ',notifyType);
                
                // Create a new object to trigger Angular change detection
                this.notificationSettings[category.category][notifyType] = {
                  ...current,
                  inApp: false,
                  email: false
                };
              }
            }
          }
        }

        this.isLoading= false;

      }
    }),((err:any) =>{
      this.util.stopLoader();
      console.log(err);      
    });
  }

  blockedList:any;
  subject :Subscription;
  isLoading:boolean = false;
  getBlockedList(userId:any){
    this.util.startLoader();
    this.isLoading = true;
    this.subject = this.api.create('notification/findBlockUserList/'+userId,{}).subscribe((res:any) =>{
      this.util.stopLoader();
      if(res.code == '00000'){
        // const data = res.data?.blocklist[0]?.notifyList;
        // this.blockedList = data?.map(item => item.notifyType) || [];
        const notifyList = res.data?.blocklist[0]?.notifyTypeList || [];
        const emailList = res.data?.blocklist[0]?.emailTypeList || [];

        this.blockedList = [...notifyList, ...emailList];

        this.getNotificationsList(this.userType);
      }
    }),((err:any) =>{
      console.log(err);
      this.util.stopLoader();
    });
  }

  save(){
    console.log('notification list ;: ',this.notificationList);
    
    const uncheckedItems: {
      category: string;
      notifyType: string;
      type: 'NOTIFICATION' | 'EMAIL';
    }[] = [];

    this.notificationList.forEach(category => {
      category.items.forEach(item => {
        const setting = this.notificationSettings[category.category][item.notifyType];        
        if (setting.type === 'NOTIFICATION'  && !setting.inApp) {
          uncheckedItems.push({
            category: category.category,
            notifyType: item.notifyType,
            type: 'NOTIFICATION'
          });
        }else if (setting.type === 'EMAIL'  && !setting.email) {
          uncheckedItems.push({
            category: category.category,
            notifyType: item.notifyType,
            type: 'EMAIL'
          });
        }
      });
    });

    console.log('Unchecked items:', uncheckedItems);

    this.util.startLoader();
    const payload = {
      userId : this.userId,
      userName : this.userName,
      status : 'INACTIVE',
      notifyList: uncheckedItems || []
    }
    this.api.create('notification/block',payload).subscribe((res:any) => {
      this.util.stopLoader();
      if(res.code == '00000'){
        this.successMessage('Notification Settings Updated');
      }else {
        Swal.fire('Error while update','','error');
      }
    }),((err : any) =>{
      console.log(err);
      this.util.stopLoader();      
    });  

  }

  successMessage(msg:any){
    Swal.fire({
      icon: "success",
      title: msg,
      text: "",
      showConfirmButton: false,
      timer: 2000,
    });
  }

}







